import { memo } from 'react';
import './GenericIcon.scss';
import { GenericIconProps } from './GenericIcon.types';

/**
 * Generic icon component to display a chosen icon from the total possible icons allowed via the scss.
 *
 * @param iconType - {@link GenericIconProps.iconType iconType} description.
 * @param ariaLabel - {@link GenericIconProps.ariaLabel ariaLabel} description.
 * @param title - {@link GenericIconProps.title title} description.
 * @param ariaHidden - {@link GenericIconProps.ariaHidden ariaHidden} description.
 */
const GenericIcon = memo(({
    iconType,
    ariaLabel,
    ariaHidden,
    title,
}: GenericIconProps) => {
    return (
        <i
            role={'img'}
            aria-label={ariaLabel}
            className={'icon-' + iconType}
            title={title}
            aria-hidden={ariaHidden}
        />
    );
});

export default GenericIcon;
